export default (axios, path = '/game') => ({
  findAllActiveGames: async () => {
    return await axios.get(`${path}`)
  },
  readyUserInGame: async (ready) => {
    return await axios.put(`${path}/user/ready?ready=${ready}`)
  },
  findAllTeamTurnHistoryByGameIdAndTurn: async ({gameId, turn}) => {
    return await axios.get(`${path}/team-stats`, {
      gameId,
      turn
    })
  },
  findOne: async (id) => {
    return await axios.get(`${path}/${id}`)
  },
  findOneWithData: async (id) => {
    const game = await axios.get(`${path}/${id}/data`)
    return game;
  },
  mockCreateGame: async () => {
    return await axios.get(`${path}/mock-create`)
  },
  gameResult: async (id) => {
    return await axios.get(`${path}/data/${id}/result`)
  },
})
